import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useIsSizeRecommendationEnabled } from "@/hooks/use-is-size-recommendation-enabled";
import useTranslation from "@babackapp/translations/use-translation";
import { Navigate } from "react-router-dom";
import { SizingSimulatorCard } from "./components/sizing-simulator-card";

export default function SizingSimulatorPage() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const isSizingEnabled = useIsSizeRecommendationEnabled();

  if (!isSizingEnabled) {
    return <Navigate to={`/shops/${shop.id}`} replace />;
  }

  return (
    <div className="flex items-center justify-center">
      <div className="grid grid-cols-4 gap-4 w-full max-w-[1600px] lg:px-16 lg:py-6 px-6 py-4">
        <div className="col-span-4 mb-4 space-y-2">
          <h2 className="text-2xl leading-6 font-semibold text-foreground">
            {t("sizing.simulatorPageTitle")}
          </h2>
          <p className="text-sm leading-relaxed text-muted-foreground max-w-[600px]">
            {t("sizing.simulatorPageSubtitle")}
          </p>
        </div>

        <div className="col-span-4">
          <SizingSimulatorCard />
        </div>
      </div>
    </div>
  );
}
